import { render, staticRenderFns } from "./PFrunwizard.vue?vue&type=template&id=9ed794c0"
import script from "./PFrunwizard.vue?vue&type=script&lang=js"
export * from "./PFrunwizard.vue?vue&type=script&lang=js"
import style0 from "./PFrunwizard.vue?vue&type=style&index=0&id=9ed794c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports